import { deleteReq, get, post } from '../../infra/rest';
import requestConfig from '../config/request';
import { SupportAccessDuration, SupportAccessRevokeResponse, SupportAccessStatus } from '../typings/support-access';

const SUPPORT_ACCESS_PATH = '/v1/organization/support-access';

export const getSupportAccessStatus = async (): Promise<SupportAccessStatus> => {
  return get<SupportAccessStatus>(`${requestConfig.aiBotBaseUrl}${SUPPORT_ACCESS_PATH}`, undefined, true, false, true);
};

export const grantSupportAccess = async (durationDays: SupportAccessDuration): Promise<SupportAccessStatus> => {
  return post<SupportAccessStatus>(
    `${requestConfig.aiBotBaseUrl}${SUPPORT_ACCESS_PATH}`,
    { body: JSON.stringify({ durationDays }) },
    true,
    false,
    true
  );
};

export const revokeSupportAccess = async (): Promise<SupportAccessRevokeResponse> => {
  return deleteReq<SupportAccessRevokeResponse>(
    `${requestConfig.aiBotBaseUrl}${SUPPORT_ACCESS_PATH}`,
    undefined,
    true,
    false,
    true
  );
};
